import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { of, Subscription, switchMap } from 'rxjs';
import { RbtTransitionStatus } from '../../../../models/rbtTransitionStatus';
import { RbtTransitionService } from '../../../../core/services/rbt-transition.service';
import { OnboardingService } from '../../../../core/services/onboarding.service';
import { LicenseInfosModel } from '../../../../models/onBoardingModels';

@Component({
  selector: 'app-rbt-transition',
  templateUrl: './rbt-transition.component.html',
  standalone: false
})
export class RbtTransitionComponent implements OnChanges, OnDestroy {
  @Input() status: RbtTransitionStatus;
  @Input() userId: number;
  examDate = '';
  busy = false;
  error = '';
  showUpload = false;
  confirmedRbt = false;
  file: File;
  license: LicenseInfosModel = { licenseNumber: '', isBoardCertification: 'true', isRbtCredential: true };
  private subscriptions = new Subscription();

  constructor(private service: RbtTransitionService, private onboarding: OnboardingService) { }

  ngOnChanges() {
    if (!this.busy) this.examDate = this.status?.examDate?.substring(0, 10) || '';
  }

  saveDate() {
    if (this.busy || !this.status?.canEdit || !this.examDate) return;
    const submittedDate = this.examDate;
    this.busy = true;
    this.error = '';
    this.subscriptions.add(this.service.saveExamDate(submittedDate).subscribe({
      next: status => this.acceptStatus(status),
      error: error => { this.examDate = this.status?.examDate?.substring(0, 10) || ''; this.showError(error); }
    }));
  }

  refresh() {
    if (this.busy) return;
    this.busy = true;
    this.error = '';
    this.subscriptions.add(this.service.getStatus().subscribe({ next: status => this.acceptStatus(status), error: error => this.showError(error) }));
  }

  chooseFile(event: Event) {
    this.file = (event.target as HTMLInputElement).files?.[0];
    this.license.rbtUploadToken = null;
  }

  upload() {
    if (this.busy || !this.confirmedRbt || !this.file || !this.license.originationDate || !this.license.issueDate || !this.license.licenseNumber) return;
    if (!this.status.credentialUploadTypeID) { this.error = 'The Licenses/Certifications upload type is not configured. Contact HR.'; return; }
    const file = this.file;
    const license = { ...this.license };
    const employeeId = this.userId;
    this.busy = true;
    this.error = '';
    const operation = license.rbtUploadToken ? of({ uploadToken: license.rbtUploadToken }) : this.service.beginCredentialUpload();
    this.subscriptions.add(operation.pipe(switchMap(result => {
      this.license.rbtUploadToken = result.uploadToken;
      license.rbtUploadToken = result.uploadToken;
      return this.onboarding.uploadFile(this.status.credentialUploadTypeID.toString(), [file], employeeId, true, undefined, license);
    }), switchMap(() => this.service.getStatus())).subscribe({
        next: status => { this.showUpload = false; this.file = null; this.confirmedRbt = false; this.acceptStatus(status); },
        error: error => this.showError(error)
      }));
  }

  acknowledge() {
    if (this.busy) return;
    this.busy = true;
    this.error = '';
    this.subscriptions.add(this.service.acknowledgeSignaturePrompt().subscribe({ next: status => this.acceptStatus(status), error: error => this.showError(error) }));
  }

  private acceptStatus(status: RbtTransitionStatus) {
    this.status = status;
    this.examDate = status.examDate?.substring(0, 10) || '';
    this.busy = false;
  }

  private showError(error: any) {
    this.error = typeof error?.error === 'string' ? error.error : error?.error?.message || error?.message || 'The request failed. Please try again.';
    this.busy = false;
  }

  ngOnDestroy() { this.subscriptions.unsubscribe(); }
}
